import { io } from 'socket.io-client';

let socketInstance = null;

// ── Socket connection URL configuration ──────────────────────────
// Local development: Connect directly to backend on port 5000
// Production (Render): Connect to backend service URL
const getSocketURL = () => {
  const hostname = window.location.hostname;

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5000';
  }

  // Production - Render backend
  return 'https://nexa-message-api.onrender.com';
};

export const initSocket = (token) => {
  // Return existing connection if already connected
  if (socketInstance?.connected) {
    return socketInstance;
  }

  // Disconnect any existing socket instance
  if (socketInstance) {
    socketInstance.disconnect();
    socketInstance = null;
  }

  const url = getSocketURL();
  console.log('[Nexa Socket] connecting to', url);

  // Create new socket connection
  socketInstance = io(url, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 15000,
  });

  // Socket event handlers
  socketInstance.on('connect', () => {
    console.log('[Nexa Socket] ✅ connected:', socketInstance.id);
  });

  socketInstance.on('connect_error', (err) => {
    console.error('[Nexa Socket] ❌ connection error:', err.message);
    console.error('[Nexa Socket] Tried to reach:', url);
  });

  socketInstance.on('disconnect', (reason) => {
    console.log('[Nexa Socket] disconnected:', reason);
  });

  socketInstance.on('reconnect', (attempt) => {
    console.log('[Nexa Socket] ✅ reconnected after', attempt, 'attempts');
  });

  return socketInstance;
};

export const getSocket = () => socketInstance;

export const disconnectSocket = () => {
  if (socketInstance) {
    socketInstance.disconnect();
    socketInstance = null;
  }
};

export const emitWithAck = (event, data, timeoutMs = 8000) => {
  return new Promise((resolve, reject) => {
    if (!socketInstance?.connected) {
      reject(new Error('Socket not connected'));
      return;
    }
    
    const timer = setTimeout(() => {
      reject(new Error('emitWithAck timeout'));
    }, timeoutMs);
    
    socketInstance.emit(event, data, (response) => {
      clearTimeout(timer);
      resolve(response);
    });
  });
};